// extracted by mini-css-extract-plugin
export default {"header":"a2l7aFFWzgfcsXm","mobile":"Ba5uF3jEa_mFNya","buttons-container":"Ih0h9giCFqruB1N","close":"RK3Si6SrfHJDAzY","search":"CmjuULopxFRoC99","volume":"RZMxn8J9fSuVSe_"};